import {Order} from 'src/app/models'

export enum EAgenStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INVITED = 'INVITED',
}

export interface IAgen {
  id: string
  agent_id: string
  name: string
  mobile_number: string
  email: string
  employee_number: string
  status: keyof typeof EAgenStatus
  company: {
    id: string
    code: string
    name: string
  }
  departments: {
    id: string
    code: string
    name: string
  }[]
}

export interface IAgenDetail extends IAgen {
  first_name: string
  last_name?: string | null
}

export interface IAgenRequest {
  employee_number?: string | null
  first_name: string
  last_name?: string | null
  mobile_number: string
  email?: string
  company_id?: string
  department_ids?: string[]
}

export interface IAgenQuery {
  search?: string
  page?: number
  size?: number
  sort?: string
  order?: Order
  statuses?: string[]
  department_ids?: string[]
  company_ids?: string[]
}

interface IAgenBulkValue {
  id?: string
  value: string
  is_valid: boolean
}

export interface IAgenBulkRequest {
  first_name: IAgenBulkValue
  last_name: IAgenBulkValue
  email: IAgenBulkValue
  employee_number: IAgenBulkValue
  mobile_number: IAgenBulkValue
  company: IAgenBulkValue
  departments: IAgenBulkValue[]
}
